module.exports = __webpack_public_path__ + "img/Gødning.5ceb9ac8.jpg";